import React, { useContext } from 'react';

import { GridRow } from '../../layout/Grid/GridRow';
import { GridColumn } from '../../layout/Grid/GridColumn';
import { useBreakpoint } from '../../../hooks/useBreakpoint';

import type { ProgressGroupContextType } from './ProgressGroupContext';
import { ProgressGroupContext } from './ProgressGroupContext';

export type ProgressGroupItemProps = {
  children: React.ReactElement;
  label: string | React.ReactElement;
  lastItem?: boolean;
};

export const ProgressGroupItem = ({
  label,
  children,
  lastItem = false,
}: ProgressGroupItemProps) => {
  const { isMobile, isTablet } = useBreakpoint();
  const { minimal, stacked }: ProgressGroupContextType =
    useContext(ProgressGroupContext);
  const child = React.Children.map(children, kid =>
    React.cloneElement(kid, {
      ...kid.props,
      backgroundColor: 'light gray',
      size: 'large',
    })
  );

  const setGutterBottom = (): string => {
    if (minimal && lastItem) return '0';
    return isMobile && !lastItem ? '24px' : '8px';
  };

  return (
    <GridRow
      gutterBottom={setGutterBottom()}
      columns={2}
      stretched
      name="PROGRESS_GROUP_ITEM"
    >
      <GridColumn name="PROGRESS_GROUP_BAR" width={stacked || isTablet ? 8 : 9}>
        {child}
      </GridColumn>
      <GridColumn
        width={stacked || isTablet ? 4 : 3}
        name="PROGRESS_GROUP_LABEL"
      >
        {label}
      </GridColumn>
    </GridRow>
  );
};
